var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup25(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    strokeOpacity: 0.4,
    stroke: "#F1A200",
    fillOpacity: 0.14,
    fill: "#F1A200",
    cx: 12,
    cy: 12,
    r: 11.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6)",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.273
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 1.636
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.036 7.636a.9.9 0 0 0 .18.993l.033.033a1.09 1.09 0 1 1-1.544 1.543l-.032-.032a.9.9 0 0 0-.993-.18.9.9 0 0 0-.545.823v.093a1.09 1.09 0 1 1-2.182 0v-.049a.9.9 0 0 0-.59-.824.9.9 0 0 0-.992.18l-.033.033a1.09 1.09 0 1 1-1.543-1.544l.032-.032a.9.9 0 0 0 .18-.993.9.9 0 0 0-.823-.545H1.09a1.09 1.09 0 1 1 0-2.182h.049a.9.9 0 0 0 .824-.59.9.9 0 0 0-.18-.992l-.033-.033a1.09 1.09 0 1 1 1.544-1.543l.032.032a.9.9 0 0 0 .993.18h.044a.9.9 0 0 0 .545-.823V1.09a1.09 1.09 0 0 1 2.182 0v.049a.9.9 0 0 0 .545.824.9.9 0 0 0 .993-.18l.033-.033a1.09 1.09 0 1 1 1.543 1.544l-.032.032a.9.9 0 0 0-.18.993v.044a.9.9 0 0 0 .823.545h.093a1.09 1.09 0 1 1 0 2.182h-.049a.9.9 0 0 0-.824.545z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup25);
export default __webpack_public_path__ + "static/media/group-25.cc74edaeac8d1b8588ad2c5934e7986b.svg";
export { ForwardRef as ReactComponent };